import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { LetDirective } from '@ngrx/component';

import { MaterialModule } from '@lockton-apps/material';
import { InitialsPipe, UiModule } from '@lockton-apps/shared/ui/lui';
import { GetPipe, ToStringPipe } from '@lockton-apps/shared/util/ng-lodash';

import { DynamicTableColumnTemplate } from '../column-template.directive';

interface InitialsProps {
  path: string;
  size: number;
  initialsOnly: boolean;
}

@Component({
  selector: 'la-dynamic-table-template-initials',
  imports: [
    CommonModule,
    MaterialModule,
    LetDirective,
    GetPipe,
    UiModule,
    ToStringPipe,
    InitialsPipe,
  ],
  templateUrl: './dynamic-table-template-initials.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DynamicTableTemplateInitialsComponent extends DynamicTableColumnTemplate<InitialsProps> {}
